import React, { Fragment } from 'react';
import {
  Card, CardBody, Col, ButtonToolbar,
} from 'reactstrap';
import MainIcon from 'mdi-react/AccountCheckIcon';
import CheckboxMarkedCircleIcon from 'mdi-react/MagnifyIcon';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
  isTablet
} from "react-device-detect";

const EmailConfirmationCard = ( props ) => {

  return (
  <Col md={12}>
    <Card>
      <CardBody>
        <div className={`email-confirmation`}>
          <div className="email-confirmation__icon">
            <MainIcon className="email-confirmation__mail" />
            <CheckboxMarkedCircleIcon className="email-confirmation__check" />
          </div>
          <h3 className="email-confirmation__title">No Contacts Found</h3>
         
        </div>
      </CardBody>
    </Card>
  </Col>
  )
};


export default EmailConfirmationCard;
